import { Typography } from '@material-ui/core';

import { IndicatorEvent } from 'generated';
import { formatNumberToBR } from 'utils';

import { DaysRender } from './components';
import { useStyles } from './styles';

interface AboutWrapperProps {
  indicatorEvent: IndicatorEvent;
}

export function AboutWrapper({
  indicatorEvent,
}: AboutWrapperProps): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.partipantsContainer}>
        <div className={classes.participantsWrapper}>
          <Typography className={classes.participantsCount}>
            {formatNumberToBR(indicatorEvent.participatingSchools)}
          </Typography>
          <Typography
            className={classes.participantsInfo}
            color="textSecondary"
            variant="subtitle2"
          >
            Escolas participantes em toda a rede
          </Typography>
        </div>
        <div className={classes.participantsWrapper}>
          <Typography className={classes.participantsCount}>
            {formatNumberToBR(indicatorEvent.participatingStudents)}
          </Typography>
          <Typography
            className={classes.participantsInfo}
            color="textSecondary"
            variant="subtitle2"
          >
            Participantes em toda a rede
          </Typography>
        </div>
      </div>
      <DaysRender days={indicatorEvent.days} />
    </div>
  );
}
